import { SciDomain } from 'types';

import { createCrudApi } from './crud.api';

export const sciDomainsApi = createCrudApi<SciDomain>('/sci-domains');
